import { z } from 'zod';
/** RunPod (docs 56–60). European datacenters only by default (Jan, 2026-10-19): EU, EEA, Switzerland, UK. */
export const EU_COUNTRY_CODES = Object.freeze([
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'CH', 'GB',
]);
/** The smallest GPU that runs Couch's models comfortably. */
export const MIN_GPU_MEMORY_GB = 16;
export const RunPodCloudSchema = z.enum(['secure', 'community']);
export const AvailabilitySchema = z.enum(['NONE', 'LOW', 'MEDIUM', 'HIGH']);
/** One GPU type as RunPod's catalog lists it (v2 OpenAPI, 2026-10-20). Untrusted: parsed before use. */
export const RunPodGpuTypeSchema = z.object({
    id: z.string().min(1).max(100),
    name: z.string().max(100),
    manufacturer: z.string().max(20),
    memory: z.number().min(0),
    price: z.object({ secure: z.number().min(0), community: z.number().min(0) }),
    dataCenters: z.array(z.object({ id: z.string().max(40), name: z.string().max(100), availability: AvailabilitySchema.catch('NONE') })).max(200).default([]),
});
export const RunPodCloudOfferSchema = z.object({
    pricePerHour: z.number().min(0),
    availability: AvailabilitySchema,
    dataCenters: z.array(z.string()),
});
export const RunPodGpuOfferSchema = z.object({
    id: z.string(),
    name: z.string(),
    memoryGb: z.number(),
    clouds: z.object({ secure: RunPodCloudOfferSchema.optional(), community: RunPodCloudOfferSchema.optional() }),
    cheapest: z.object({ cloud: RunPodCloudSchema, pricePerHour: z.number() }),
});
/** GET /api/v1/cloud/runpod/catalog — `via` names the key holder ("couch" or a machine's name). */
export const RunPodCatalogResponseSchema = z.object({ gpus: z.array(RunPodGpuOfferSchema), via: z.string() });
/** What an agent answers for `runpod_request` (doc 56). */
export const RunPodAnswerSchema = z.object({ status: z.number().int().min(100).max(599), body: z.unknown() });
//# sourceMappingURL=runpod.js.map